import PropTypes from 'prop-types';
import styles from './FJMobileImageEnhancerCreation.module.less';
import FJImage from '../../../common/components/FJImage/FJImage';
import { useMemo, useRef, useEffect, useState } from 'react';
import FJConstant from '../../../constants/FJConstant';
import FJMobileImageItem from '../../FJMainPreview/FJMobileImageItem/FJMobileImageItem';

const FJMobileImageEnhancerCreation = props => {
    const { uploadImageList, imageEnhancerCreationList, taskStatus, reGenerate } = props;
    const [previewRect, setPreviewRect] = useState({});
    const containerRef = useRef(null);
    const creationData = useMemo(() => {
        return imageEnhancerCreationList[0];
    }, [imageEnhancerCreationList]);
    const uploadData = useMemo(() => uploadImageList[0], [uploadImageList]);

    useEffect(() => {
        if (containerRef.current && (uploadData || creationData)) {
            const containerRect = containerRef.current?.getBoundingClientRect() || {};
            const { width, height } = uploadData || creationData;
            const ratio = width / height;
            let w = containerRect.width - 16 * 2;
            let h = w / ratio;
            if (h > containerRect.height - 16 * 2) {
                h = containerRect.height - 16 * 2;
                w = h * ratio;
            }
            setPreviewRect({
                width: w,
                height: h,
            });
        }
    }, [containerRef, uploadData, creationData]);
    const _renderMainView = () => {
        if (taskStatus === FJConstant.DEFAULT) {
            return <FJImage boxClassName={styles.preview_image_box} style={previewRect} imgSrc={uploadData.src} />;
        } else {
            return (
                <div className={styles.item_box} style={previewRect}>
                    <FJMobileImageItem item={creationData} onPreview={() => {}} reGenerate={reGenerate} />
                </div>
            );
        }
    };
    return (
        <div className={styles.container} ref={containerRef}>
            {_renderMainView()}
        </div>
    );
};
FJMobileImageEnhancerCreation.propTypes = {
    uploadImageList: PropTypes.array,
    imageEnhancerCreationList: PropTypes.array,
    taskStatus: PropTypes.string,
    reGenerate: PropTypes.func,
};
export default FJMobileImageEnhancerCreation;
